import React from 'react';

// Light hairline strip, per the updated design — not the dark glow band the other landing pages use,
// so this keeps its own `lp-vcstats-*` classes rather than restyling the shared `.lp-stats`.
const STATS = [
    { count: 40, suffix: '+', label: 'VCs on the platform' },
    { raw: 'Free', label: 'to investors and advisors' },
    { count: 60, prefix: '~', suffix: '%', label: 'AI auto-populated modules' },
    { count: 13, suffix: ' wks', label: 'saved on a Series A (mid scenario)' },
    { raw: '360°', label: 'Deal View, always live' },
];

const VCStatsBand = () => (
    <section className="lp-vcstats">
        <div className="lp-vcstats-strip">
            {STATS.map((s, i) => (
                <div className="lp-vcstats-item" key={i} data-lp-reveal data-lp-delay={i * 70}>
                    {s.raw
                        ? <div className="lp-vcstats-num">{s.raw}</div>
                        : <div className="lp-vcstats-num" data-count={s.count} data-prefix={s.prefix} data-suffix={s.suffix}>{s.prefix}{s.count}{s.suffix}</div>}
                    <div className="lp-vcstats-label">{s.label}</div>
                </div>
            ))}
        </div>
    </section>
);

export default VCStatsBand;
